import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import WindowsDoorHero from './components/WindowsDoorHero';
import WindowsDoorServices from './components/WindowsDoorServices';
import WindowsDoorTypesElPaso from './components/WindowsDoorTypesElPaso';
import ContractorDirectory from './components/ContractorDirectory';
import ComparisonChecklist from './components/ComparisonChecklist';
import WindowsDoorFAQ from './components/WindowsDoorFAQ';

export default function WindowsDoorPage() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Header />
      <main>
        <WindowsDoorHero />
        <WindowsDoorServices />
        <WindowsDoorTypesElPaso />
        <ContractorDirectory />
        <ComparisonChecklist />
        <WindowsDoorFAQ />
      </main>
      <Footer />
    </div>
  );
}
